
import { Button, Form, Input, Modal, Popover, Row, Col } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hideEmailDialog, submitEmailNotification, changeWatchlistInput } from './sblActions';
import { getDateRule } from '../utils/antUtils'

const { TextArea } = Input;


class SblEmailModalComponent extends Component {

  cancelDialog() {
    this.props.dispatch(hideEmailDialog());
  }

  submit() {

    if(!this.props.watchlistChanged.match(getDateRule().pattern)){
      return alert('Ogiltigt datum.');
    }

    this.props.dispatch(submitEmailNotification(
      this.props.watchlistIds,
      this.props.emails,
      this.props.watchlistChanged,
      this.props.watchlistSubject,
      this.props.watchlistContent));
  }

  render() {

    let footer = [];
    footer.push(<Button key="back" onClick={() => this.cancelDialog()}>Avbryt</Button>);
    footer.push(<Button key="submit" type="primary" onClick={() => this.submit()}>Skicka</Button>);

    let emailsString = this.props.emails.length > 4 ? `${this.props.emails.length} e-post adresser` :
      this.props.emails.join(', ');

    let description = `Skickas till ${emailsString}`;

    return (

      <Modal
        title='Skicka e-post'
        visible={this.props.showEmailDialog}
        onCancel={() => this.cancelDialog()}
        footer={footer}
        maskClosable={false}
        width={1000}
      >
        <div>
          <Form onSubmit={this.submit}>
            <Row>
              <Col span={2}>
                Datum
              </Col>
              <Col span={6}>
                <Input onChange={(e) => this.props.dispatch(changeWatchlistInput('watchlistChanged', e.target.value))} value={this.props.watchlistChanged} />
              </Col>
              <Col span={1}></Col>
              <Col>
                Detta datum kommer att visas som "Senast Ändrad" under kundens bevakningar
              </Col>
            </Row>
            <Row>
              <Col span={2} style={{ marginTop: 15 }}>
                Ämne
              </Col>
              <Col span={22}>
                <Input onChange={(e) => this.props.dispatch(changeWatchlistInput('watchlistSubject', e.target.value))} style={{ margin: '10px 0' }} value={this.props.watchlistSubject} />
              </Col>
            </Row>
            <TextArea Rows={15} onChange={(e) => this.props.dispatch(changeWatchlistInput('watchlistContent', e.target.value))} value={this.props.watchlistContent} />
          </Form>
        </div>
        <div>
          {description}
        </div>

      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  showEmailDialog: state.sbl.showEmailDialog,
  id: state.sbl.id,
  title: state.sbl.title,
  sfsNumber: state.sbl.sfsNumber,
  emails: state.sbl.emails,
  watchlistIds: state.sbl.watchlistIds,
  watchlistSubject: state.sbl.watchlistSubject,
  watchlistChanged: state.sbl.watchlistChanged,
  watchlistContent: state.sbl.watchlistContent
});

export default connect(mapStateToProps)(SblEmailModalComponent);


// WEBPACK FOOTER //
// ./src/sbl/sblEmailModalComponent.js